/*
 * Orbit Trends — PDP usability enhancements
 * 1. Moves the size-guide trigger inline with the variant picker label row
 *    (it renders at the bottom of the section otherwise).
 * 2. Adds a share row (native share / copy link / email / social) under the
 *    buy buttons.
 * Both are idempotent and re-applied after Shopify section morphs.
 */
(function () {
  'use strict';

  function placeSizeGuide() {
    var trigger = document.querySelector('.orbit-size-guide__trigger');
    var legend = document.querySelector('.product-information variant-picker fieldset.variant-option legend');
    if (!trigger || !legend || legend.querySelector('.orbit-size-guide__trigger')) return;
    trigger.classList.add('orbit-size-guide__trigger--inline');
    legend.appendChild(trigger);
  }

  function shareTargets(url, title) {
    var eu = encodeURIComponent(url);
    var et = encodeURIComponent(title);
    return [
      { label: 'Share on Facebook', href: 'https://www.facebook.com/sharer/sharer.php?u=' + eu, icon: '<svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M9.1 16v-7h2.3l.4-2.8H9.1V4.4c0-.8.2-1.4 1.4-1.4h1.4V.5C11.6.4 10.8.3 9.9.3 7.9.3 6.5 1.5 6.5 4v2.2H4.2V9h2.3v7h2.6z"/></svg>' },
      { label: 'Share on Pinterest', href: 'https://pinterest.com/pin/create/button/?url=' + eu + '&description=' + et, icon: '<svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M8 0a8 8 0 0 0-2.9 15.4c0-.6 0-1.4.1-2l1-4.1s-.2-.5-.2-1.2c0-1.2.7-2 1.5-2 .7 0 1 .5 1 1.2 0 .7-.4 1.7-.7 2.7-.2.8.4 1.5 1.2 1.5 1.5 0 2.5-1.9 2.5-4.1 0-1.7-1.1-3-3.2-3a3.7 3.7 0 0 0-3.8 3.7c0 .7.2 1.2.5 1.5.1.2.2.3.1.5l-.2.7c0 .2-.2.3-.4.2-1.1-.5-1.7-1.7-1.7-3.1 0-2.3 2-5.1 5.8-5.1 3.1 0 5.2 2.3 5.2 4.7 0 3.2-1.8 5.6-4.4 5.6-.9 0-1.7-.5-2-1l-.5 2.1c-.2.7-.6 1.5-1 2A8 8 0 1 0 8 0z"/></svg>' },
      { label: 'Share on WhatsApp', href: 'https://wa.me/?text=' + et + '%20' + eu, icon: '<svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M13.6 2.3A7.9 7.9 0 0 0 8 0 8 8 0 0 0 1 11.9L0 16l4.2-1.1A8 8 0 0 0 16 8c0-2.1-.9-4.1-2.4-5.7zM8 14.7c-1.2 0-2.4-.3-3.4-.9l-.2-.2-2.5.7.7-2.5-.2-.2A6.6 6.6 0 1 1 8 14.7zm3.6-5c-.2-.1-1.2-.6-1.4-.6-.2-.1-.3-.1-.4.1l-.6.7c-.1.1-.2.2-.4.1-1.2-.6-2-1.1-2.8-2.4-.2-.4.2-.3.6-1.1 0-.2 0-.3-.1-.4L5.9 4.6c-.1-.4-.3-.3-.4-.3h-.4c-.1 0-.4 0-.5.3-.2.2-.7.7-.7 1.7s.7 2 .8 2.1c.1.2 1.4 2.1 3.3 3 1.2.5 1.7.6 2.3.5.4 0 1.2-.5 1.3-1 .2-.4.2-.9.1-1 0-.1-.2-.1-.4-.2z"/></svg>' },
    ];
  }

  function copyIcon() {
    return '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M6.5 9.5a3 3 0 0 0 4.2 0l2.9-2.9a3 3 0 1 0-4.2-4.2l-1 1"/><path d="M9.5 6.5a3 3 0 0 0-4.2 0L2.4 9.4a3 3 0 1 0 4.2 4.2l1-1"/></svg>';
  }

  function buildShareRow() {
    var buyButtons = document.querySelector('.product-information .buy-buttons-block');
    if (!buyButtons || document.querySelector('.orbit-share')) return;

    var url = location.origin + location.pathname;
    var title = document.title.split('–')[0].trim();

    var row = document.createElement('div');
    row.className = 'orbit-share';
    row.innerHTML = '<span class="orbit-share__label">Share</span>';

    // Copy link with confirmation
    var copyBtn = document.createElement('button');
    copyBtn.type = 'button';
    copyBtn.className = 'orbit-share__btn';
    copyBtn.setAttribute('aria-label', 'Copy link');
    copyBtn.title = 'Copy link';
    copyBtn.innerHTML = copyIcon();
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(url).then(function () {
        copyBtn.classList.add('is-copied');
        copyBtn.setAttribute('aria-label', 'Link copied');
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          copyBtn.setAttribute('aria-label', 'Copy link');
        }, 2000);
      });
    });
    row.appendChild(copyBtn);

    // Email
    var mail = document.createElement('a');
    mail.className = 'orbit-share__btn';
    mail.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
    mail.setAttribute('aria-label', 'Share by email');
    mail.title = 'Share by email';
    mail.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="1.5" y="3" width="13" height="10" rx="1"/><path d="m2 4 6 5 6-5"/></svg>';
    row.appendChild(mail);

    shareTargets(url, title).forEach(function (t) {
      var a = document.createElement('a');
      a.className = 'orbit-share__btn';
      a.href = t.href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', t.label);
      a.title = t.label;
      a.innerHTML = t.icon;
      row.appendChild(a);
    });

    // Native share where supported (mostly mobile)
    if (navigator.share) {
      var native = document.createElement('button');
      native.type = 'button';
      native.className = 'orbit-share__btn';
      native.setAttribute('aria-label', 'More sharing options');
      native.title = 'More sharing options';
      native.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="12.5" cy="3" r="2"/><circle cx="3.5" cy="8" r="2"/><circle cx="12.5" cy="13" r="2"/><path d="M5.3 7 10.7 4M5.3 9l5.4 3"/></svg>';
      native.addEventListener('click', function () {
        navigator.share({ title: title, url: url }).catch(function () {});
      });
      row.appendChild(native);
    }

    buyButtons.insertAdjacentElement('afterend', row);
  }

  var applying = false;
  function apply() {
    if (applying) return;
    applying = true;
    try {
      placeSizeGuide();
      buildShareRow();
    } finally {
      applying = false;
    }
  }

  function init() {
    apply();
    var section = document.querySelector('.product-information');
    if (!section || !window.MutationObserver) return;
    var timer = null;
    new MutationObserver(function () {
      // debounce: morphs replace large chunks of the details column
      clearTimeout(timer);
      timer = setTimeout(apply, 120);
    }).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', apply);
})();
